import { library, dom } from '@fortawesome/fontawesome-svg-core';

import {
  faPipe as faPipeSolid,
  faPhone as faPhoneSolid,
  faChevronUp as faChevronUpSolid,
  faChevronDown as faChevronDownSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faArrowUp as faArrowUpSolid,
  faArrowDown as faArrowDownSolid,
  faHome as faHomeSolid,
  faArrowRight as faArrowRightSolid,
  faEllipsis as faEllipsisSolid,
  faCheck as faCheckSolid,
  faArrowLeft as faArrowLeftSolid,
  faPlus as faPlusSolid,
  faMinus as faMinusSolid,
  faComments as faCommentsSolid,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faWhatsapp as faWhatsappBrands,
  faFacebook as faFacebookBrands,
  faInstagram as faInstagramBrands,
  faLinkedin as faLinkedInBrands,
  faLinkedinIn as faLinkedInInBrands,
  faXTwitter as faXTwitterBrands,
} from '@fortawesome/free-brands-svg-icons';

library.add([
  faChevronUpSolid,
  faChevronDownSolid,
  faChevronLeftSolid,
  faChevronRightSolid,
  faWhatsappBrands,
  faXTwitterBrands,
  faFacebookBrands,
  faInstagramBrands,
  faLinkedInBrands,
  faLinkedInInBrands,
  faPhoneSolid,
  faHomeSolid,
  faArrowLeftSolid,
  faArrowRightSolid,
  faArrowUpSolid,
  faArrowDownSolid,
  faPlusSolid,
  faMinusSolid,
  faPipeSolid,
  faEllipsisSolid,
  faCheckSolid,
  faCommentsSolid,
]);

dom.watch();
